import "rc-tooltip/assets/bootstrap_white.css"
import RcTooltip from "rc-tooltip"
import { ActionType } from "@rc-component/trigger/lib/interface"
import { TooltipProps as RcTooltipProps } from "rc-tooltip/lib/Tooltip"
import { ReactNode } from "react"

import { Text } from "components/Text"
import { browserInfo } from "utils"

export type TooltipProps = Pick<
    RcTooltipProps,
    | "children"
    | "overlay"
    | "classNames"
    | "placement"
    | "onVisibleChange"
    | "afterVisibleChange"
    | "getTooltipContainer"
> & {
    forceTrigger?: ActionType
    className?: string
    tooltipClassName?: string
    overlay?: ReactNode
}

const trigger = [browserInfo.isMobile() ? ("click" as ActionType) : ("hover" as ActionType)]

export function Tooltip({
    overlay,
    forceTrigger,
    className,
    tooltipClassName,
    ...props
}: TooltipProps) {
    return (
        <RcTooltip
            {...props}
            align={{ htmlRegion: "scroll" }}
            classNames={{
                body: className,
                root: tooltipClassName,
            }}
            trigger={forceTrigger ? forceTrigger : trigger}
            overlay={
                <Text color="blue-4" fontSize={3}>
                    {overlay}
                </Text>
            }
        />
    )
}
